<div class="marketing-tab">
  <div class="toolbar">
    <div>
      <h3 class="section-title">Campaigns</h3>
      <div class="subtitle">Create campaign messages and run prepared sends.</div>
    </div>
    <div class="actions">
      <mat-form-field appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select
          [(ngModel)]="campaignArchiveStatusFilter"
          (selectionChange)="onArchiveStatusFilterChange()"
          >
          @for (option of archiveStatusOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        (click)="add()"
        >
        <mat-icon>add</mat-icon>
        Add New Campaign
      </button>
    </div>
  </div>

  <div class="summary-grid">
    <div class="summary-item">
      <span class="label">Campaigns</span>
      <strong>{{ campaignCount }}</strong>
    </div>
    <div class="summary-item">
      <span class="label">Not Run</span>
      <strong>{{ getStatusCount('created') }}</strong>
    </div>
    <button
      type="button"
      class="summary-item summary-button"
      (click)="openGroups()"
      aria-label="Open campaign groups"
      >
      <span class="label">Groups</span>
      <strong>{{ groups.length }}</strong>
    </button>
  </div>

  <div class="table-wrap">
    <table class="table" mat-table matSort matSortActive="name" matSortDirection="asc" [dataSource]="tableDataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <div class="cell-primary">{{ item.name }}</div>
          <div class="cell-secondary">{{ item.description || 'No description' }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Channel</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <span class="type-pill">{{ getChannelLabel(item.channel) }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td class="cell" mat-cell *matCellDef="let item">
          <span class="status-pill" [ngClass]="getStatusClass(item.status)">
            {{ getStatusLabel(item.status) }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="groupNames">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Groups</th>
        <td class="cell cell-truncate" mat-cell *matCellDef="let item">
          {{ item.groupNames || '-' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
        <td class="cell" mat-cell *matCellDef="let item">
          {{ item.createdAt ? (item.createdAt | date:'medium') : '-' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button
            mat-icon-button
            class="action-button"
            [matMenuTriggerFor]="menu"
            [matMenuTriggerData]="{ item: item }"
            aria-label="Campaign actions"
            (click)="$event.stopPropagation()"
            >
            <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
      <tr class="listitem" mat-row *matRowDef="let rows; columns: columnNames"></tr>
    </table>
    @if (tableDataSource.data.length === 0) {
      <div class="empty">
        No marketing campaigns have been created yet.
      </div>
    }
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item [disabled]="!canRunCampaign(item)" (click)="play(item)">
          <mat-icon>play_arrow</mat-icon>
          {{ getRunActionLabel(item) }}
        </button>
        <button mat-menu-item (click)="edit(item)">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        @if (!isArchived(item)) {
          <button mat-menu-item (click)="archive(item)">
            <mat-icon>archive</mat-icon>
            Archive
          </button>
        }
        <button
          mat-menu-item
          [disabled]="!item.groups?.length"
          [matMenuTriggerFor]="groupMenu"
          [matMenuTriggerData]="{ groups: item.groups }"
          >
          <mat-icon>groups</mat-icon>
          View Group
        </button>
        <!-- <button mat-menu-item (click)="remove(item)">Delete</button> -->
        @if (!isArchived(item)) {
          <button mat-menu-item (click)="clone(item)">
            <mat-icon>content_copy</mat-icon>
            Clone
          </button>
        }
      </ng-template>
    </mat-menu>
    <mat-menu #groupMenu="matMenu">
      <ng-template matMenuContent let-groups="groups">
        @for (group of groups; track group) {
          <button mat-menu-item (click)="viewGroup(group)">
            {{ group.name }}
          </button>
        }
      </ng-template>
    </mat-menu>
  </div>
</div>
